<template>
  <button
    :class="cssClass"
    class="btn btn-sm"
    :style="cssStyle"
    type="getType"
    :disabled="loading || disabled"
  >
    <div v-if="loading" class="spinner-grow spinner-grow-sm" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <font-awesome-icon
      v-if="icon"
      :class="textColor"
      class="mx-2"
      :icon="icon"
    />
    <span :class="textColor" class="text-weight-semi-bold" v-html="label">
    </span>
  </button>
</template>
<script>
export default {
  props: {
    icon: {
      type: Array,
      required: false,
    },
    label: String,
    color: String,
    fullWidth: Boolean,
    fixWidth: Boolean,
    
    type: String,
    border: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    spanCustomCSS: String,
    buttonCustomCSS: {
      default: '',
      type: String
    }
  },

  computed: {
    cssStyle() {
      if (this.fixWidth) {
        return 'width: 160px;';
      }
      return null;
    },

    cssClass() {
      let bntColor = 'btn-primary';
      if (this.color) {
        bntColor = 'btn-' + this.color;
      }

      if (this.border) {
        bntColor += ' border border-color';
      }

      bntColor += " " + this.buttonCustomCSS;

      if (this.fullWidth) {
        return bntColor + ' btn-block';
      }
      return bntColor;
    },

    textColor() {
      let txtColor = 'text-white';
      if (this.color == 'white') {
        txtColor = 'text-grey';
      }
      return txtColor + " " + this.spanCustomCSS;
    },

    getType() {
      return this.type || 'button';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

// .custom-style-for-mobile {
//   font-size: $big;
//   font-weight: $regular-weight !important;
// }

// .btn-width-150 {
//   width: 150px !important;
// }
</style>